import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_form = _resolveComponent("v-form");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickOutsideDialog,
        onKeydown: _withKeys(_ctx.handleClickOutsideDialog, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)))
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}change_delivery_charge`),
                        "on-cancel": _ctx.handleClickCancelAdjustDeliveryAmount
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createVNode(_component_v_card, {
                        flat: "",
                        tile: ""
                    }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 변경 전 "),
                            _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.before_change')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_card_title, { class: "text-body-1 pt-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.nowDeliveryAmount), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createCommentVNode(" 변경 후 "),
                            _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.after_change')), 1 /* TEXT */),
                                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                ]),
                                _: 1 /* STABLE */,
                                __: [4]
                            }),
                            _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 py-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}notice_adjust_delivery_maximum_amount`, {
                                        adjust_delivery_maximum_amount: _ctx.adjustDeliveryAmountMaximum
                                    })), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_form, {
                                ref: "form",
                                modelValue: _ctx.valid,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.valid) = $event)),
                                onSubmit: _withModifiers(_ctx.handleClickChangeAdjustDeliveryAmount, ["prevent"])
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.formattedDeliveryAmount,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formattedDeliveryAmount) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        dense: "",
                                        "hide-details": "auto",
                                        inputmode: "numeric",
                                        "validate-on": "blur",
                                        placeholder: _ctx.$t(`common.amount_required`),
                                        suffix: _ctx.$t('common.currency'),
                                        rules: [_ctx.rules.required, _ctx.rules.maximum, _ctx.rules.notChange],
                                        class: "px-4",
                                        onKeyup: _cache[1] || (_cache[1] = ($event) => (_ctx.handleDeliveryAmountInputKeyupEvent($event.key)))
                                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "rules"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "onSubmit"])
                        ])
                    ]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_DialogFooter, {
                        cancel: true,
                        ok: true,
                        "on-cancel": _ctx.handleClickCancelAdjustDeliveryAmount,
                        "on-ok": _ctx.handleClickChangeAdjustDeliveryAmount
                    }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
